import { useAuthStore } from '~/store/auth.js'
import { useGridStore } from '~/store/grid'

let hasRun = false

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore()
  if (process.client && hasRun && authStore.isAuthenticated) return
  hasRun = true

  if (process.server) return

  const gridStore = useGridStore()

  if (!authStore.isAuthenticated) {
    return navigateTo('/login')
  }

  if (authStore.isAuthenticated) {
    await authStore
      .fetchUser()
      .then(gridStore.getGrids)
      .catch(() => authStore.logout())
  }
})
